import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { blogPosts } from './blog/posts';
export function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Blog | IntelliEats';
    // Google AdSense - inject into <head>
    if (!document.querySelector('script[src*="adsbygoogle"]')) {
      const adsScript = document.createElement('script');
      adsScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3041826185319356';
      adsScript.async = true;
      adsScript.setAttribute('crossorigin', 'anonymous');
      document.head.appendChild(adsScript);
    }
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-2383" data-mp="aus2nmy9fq50">
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2384" data-mp="fu4pw8t1mz84">
        {/* Header */}
        <header className="mb-12 text-center" data-id="element-2385" data-mp="oscb975n613d">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-2386" data-mp="or1alg7ht9gh">
            
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2387" data-mp="xlph19ot0x6v" />
            Back to Home
          </Link>
          <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight leading-tight mb-4" data-id="element-2388" data-mp="tj2hemlw67z4">
            The IntelliEats Blog
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2389" data-mp="5u9tndffb6fl">
            Insights, guides, and tips to help you understand what's really in
            your food and make smarter choices.
          </p>
        </header>

        {/* Post List */}
        <div className="space-y-8" data-id="element-2390" data-mp="9v3f805e895b">
          {blogPosts.map((post, index) => <motion.div key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-2391" data-mp="9xxyvpgl1pxo" data-mpi={index}>
            
              <Link to={`/blog/${post.slug}`} className="group block bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden" data-id="element-2392" data-mp="iwkguxs6g28w">
              
                <div className="grid sm:grid-cols-5 gap-0" data-id="element-2393" data-mp="rytp1gzz3jj4">
                  <div className="sm:col-span-2 relative overflow-hidden" data-id="element-2394" data-mp="wxdcjlu7t3dl">
                    <img src={post.image} alt={post.imageAlt} className="w-full h-48 sm:h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-2395" data-mp="74h4cobgdtj" />
                  
                    <span aria-hidden="true" className="pointer-events-none absolute bottom-2 right-2 select-none rounded-full bg-white/70 px-2 py-0.5 text-[10px] font-black tracking-tight backdrop-blur-sm" data-id="element-2396" data-mp="97j37e93twy3">
                    
                      <span className="text-slate-900/70" data-id="element-2397" data-mp="3cp193g5bgtvv">Intelli</span>
                      <span className="text-brand-600/80" data-id="element-2398" data-mp="3hncjbrzix6em">Eats</span>
                    </span>
                  </div>
                  <div className="sm:col-span-3 p-6 sm:p-8 flex flex-col justify-center" data-id="element-2399" data-mp="3a4d1hqrpnmxd">
                    <div className="flex items-center gap-3 mb-3" data-id="element-2400" data-mp="355078kyifdkr">
                      <span className="px-3 py-1 rounded-full bg-brand-50 text-brand-700 text-xs font-bold tracking-wider uppercase" data-id="element-2401" data-mp="352nmy15a4r4j">
                        {post.category}
                      </span>
                      <span className="flex items-center text-xs text-slate-400" data-id="element-2402" data-mp="2w6ep2qwya0ki">
                        <Clock className="w-3 h-3 mr-1" data-id="element-2403" data-mp="2r6a8z1zyf7ut" />
                        {post.readTime}
                      </span>
                    </div>
                    <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-3 leading-snug group-hover:text-brand-700 transition-colors" data-id="element-2404" data-mp="2hemm7eeceezo">
                      {post.title}
                    </h2>
                    <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3" data-id="element-2405" data-mp="28er4sru71nr7">
                      {post.excerpt}
                    </p>
                    <span className="inline-flex items-center text-sm font-semibold text-brand-600 group-hover:text-brand-700" data-id="element-2406" data-mp="23hhgjfijji4y">
                      Read Article
                      <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-2407" data-mp="bcjz8bve34x5" />
                    </span>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}